"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_video(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "video-mid"), /*#__PURE__*/React.createElement("g", {
    id: "e2d2b7a8-c184-4d67-8542-f6758a5c21ff",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09800210-b44f-4fa9-8155-c062129b0bec",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,87.62",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fecb00",
    strokeLinejoin: "round",
    strokeWidth: 8.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.39,56C167,53.29,172,53.22,174,58.82V134c-1.72,5.16-7,4.61-9.61,1.94L138,110v26a14,14,0,0,1-14,14H32a14,14,0,0,1-14-14V56A14,14,0,0,1,32,42h92a14,14,0,0,1,14,14V82Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 72,
    r: 10,
    fill: "none",
    stroke: "#e60000",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

var _default = ic_video;
exports.default = _default;